"use client";

import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";

interface SparklineProps {
	/** Ordered series of values (oldest → newest). */
	data: number[];
	/**
	 * Stroke colour of the line. Required, and always a design token (a
	 * `CHART_SERIES` slot or a semantic var) — a default here would be a
	 * hardcoded hex that silently ignores the theme in one colour mode.
	 */
	color: string;
	/** Height in pixels. Width fills the container. */
	height?: number;
	className?: string;
}

/**
 * Minimal axis-less trend line for inline use in KPI tiles. Renders nothing
 * when there are fewer than two points (a single point has no trend to show).
 * Graduated from the SaaS shared module (which re-exports this component).
 */
export function Sparkline({
	data,
	color,
	height = 32,
	className,
}: SparklineProps) {
	if (!data || data.length < 2) {
		return null;
	}

	const chartData = data.map((value, index) => ({ index, value }));

	return (
		<div className={className} style={{ height }}>
			<ResponsiveContainer width="100%" height="100%">
				<LineChart
					data={chartData}
					margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
				>
					<YAxis hide domain={["dataMin", "dataMax"]} />
					<Line
						type="monotone"
						dataKey="value"
						stroke={color}
						strokeWidth={2}
						dot={false}
						isAnimationActive={false}
					/>
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
}
